import axios from "axios";

export const apiClient = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/`,
    timeout: 120000,
});

apiClient.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem("token");
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export const loginAdmin = (data) => {
    return apiClient.post("/admin/login", data);
};

export const signUpAdmin = (data) => {
    return apiClient.post("/admin/register", data);
};

export const sendForgetOtp = (data) => {
    return apiClient.post("/users/send-forget-otp", data);
}

export const verifyOtp = (data) => {
    return apiClient.post("/users/verify-otp", data);
}

export const resetPassword = (data) => {
    return apiClient.post("/users/reset-password", data);
}

export const passwordChange = (data) => {
    return apiClient.patch("/admin/admin-password-change", data);
}

export const getMyDetails = () => {
    return apiClient.get("/users/me");
}

export const editProfile = (data) => {
    return apiClient.put("/admin/edit-profile", data);
}
export const getDashboard = () => {
    return apiClient.get("/admin/dashboard");
};

export const getCategory = (
    page,
    perPage,
    status,
    search,
    sortBy,
    sortType
) => {
    return apiClient.get(
        `/category/all-admin?page=${page}&perPage=${perPage}&status=${status}&search=${search}&sortBy=${sortBy}&sortType=${sortType}`
    );
};

export const getCategoryAll = (
    status,
) => {
    return apiClient.get(
        `/category/all-admin?status=${status}`
    );
};

export const addCategory = (data) => {
    return apiClient.post("/category/add", data);
}
export const updateCategory = (data, categoryId) => {
    return apiClient.put(`/category/edit/${categoryId}`, data);
};

export const getUserList = (page, perPage, search, status, isPremium, plan) => {
    return apiClient.get(`/admin/get-all-user?page=${page}&perPage=${perPage}&search=${search}&status=${status}&isPremium=${isPremium}&plan=${plan}`);
}

export const addUser = (data) => {
    return apiClient.post("/admin/add-user", data);
}

export const editUser = (data, id) => {
    return apiClient.put(`/admin/edit-user/${id}`, data);
}

export const deleteData = (endpoint, id) => {
    return apiClient.delete(`${endpoint}/${id}`);
}

export const userPasswordChange = (data, id) => {
    return apiClient.put(`/admin/password-change/${id}`, data);
}

export const getAllTemplate = (page, perPage, search, status, categoryId, fileType, templateId) => {
    return apiClient.get(`/template/all-admin?page=${page}&perPage=${perPage}&search=${search}&status=${status}&categoryId=${categoryId}&fileType=${fileType}&templateId=${templateId}`);
}

export const addTemplate = (data) => {
    return apiClient.post("/template/add", data);
}

export const editTemplate = (data, id) => {
    return apiClient.put(`/template/edit/${id}`, data);
}

export const getForm = (page, perPage, search, categoryId, templateId) => {
    return apiClient.get(`/forms/all-form?page=${page}&perPage=${perPage}&search=${search}&categoryId=${categoryId}&templateId=${templateId}`);
}

export const getTemplateByCategories = (categoryId) => {
    return apiClient.get(`/template/by-category/${categoryId}`);
}

export const getTemplateList = () => {
    return apiClient.get(`/template/all-template`);
}

export const addEntryForm = (data) => {
    return apiClient.post("/forms/add", data);
}

export const editEntryForm = (data, id, index) => {
    const query = index !== undefined && index !== null ? `?index=${index}` : '';
    return apiClient.post(`/forms/edit/${id}${query}`, data);
}

export const getFormByCompany = (search) => {
    return apiClient.get(`/forms/form-by-company?search=${search}`);
}

export const getFileById = (fileType, formId) => {
    return apiClient.get(`/forms/file/${fileType}/${formId}`, {
        responseType: 'blob',
    });
}

export const exportFile = () => {
    return apiClient.get(`/template/export-sheet`, {
        responseType: 'blob',
    });
}

export const exportEntryFile = () => {
    return apiClient.get(`/forms/export-sheet`, {
        responseType: 'blob',
    });
}

export const exportUserFile = () => {
    return apiClient.get(`/admin/export-sheet`, {
        responseType: 'blob',
    });
}

export const getTermCondition = () => {
    return apiClient.get(`/admin/get-terms-condition`);
}

export const editTermsCondition = (data, id) => {
    return apiClient.put(`/admin/edit-terms-condition/${id}`, {
        content: data
    });
}

export const getPolicy = () => {
    return apiClient.get(`/admin/get-policy`);
}

export const editPolicy = (data, id) => {
    return apiClient.put(`/admin/edit-policy/${id}`, {
        content: data
    });
}

export const getAllPlans = () => {
    return apiClient.get(`/users/get-subscription`);
}

export const editPlans = (data, id) => {
    return apiClient.put(`/admin/edit-subscription/${id}`, data);
}

export const downLoadFile = (data) => {
    return apiClient.post(`/users/downloadfile`, data,
        {
            responseType: 'blob' // 👈 important to receive binary data
        }
    );
}